import './ApplicationCard.css';
import { type LaunchableApp, type LaunchableAppExtension } from '@src/views/app_launcher/LaunchableApp';

const APPLICATION_CARD_CLASS = 'application_card';

/**
 * The jQuery query selector for the ApplicationCards.
 * Useful when trying to get the container via jQuery.
 */
export const APPLICATION_CARDS_QUERY_SELECTOR = '.' + APPLICATION_CARD_CLASS;

interface ApplicationCardProps {
  app: LaunchableApp
  id: string
  isSelected: boolean
  onClick: () => void
  onSelectAutoLaunch: () => void
}

/**
 * Creates an application card that displays the app type icon, the app name and the last modified date.
 * It also has an animated background.
 */
export const ApplicationCard = ({ app, id, isSelected, onClick, onSelectAutoLaunch }: ApplicationCardProps): JQuery => {
  const appCard = $('<div>')
    .attr('id', id)
    .addClass(isSelected ? 'selected_application' : '')
    .addClass(APPLICATION_CARD_CLASS)
    .on('click', onClick);

  const appCardContent = $('<div>')
    .addClass('application_card_content');

  const appIcon = AppIcon({ appExtension: app.extension });
  const appDetails = $('<div>')
    .addClass('application_details');

  const appName = $('<div>')
    .addClass('application_name')
    .text(app.name);

  const appModifiedDate = $('<div>')
    .text(`last modified: ${app.lastModifiedDate}`);

  const appAutoLaunch = $('<div>')
    .addClass('icon-boot-up')
    .addClass(app.autoLaunch ? 'auto-launch-on' : 'auto-launch-off')
    .on('click', onSelectAutoLaunch);

  const appCardAnimatedBackground = $('<div>')
    .addClass('ml_animated_background');

  // Hide auto-launch feature for MM applications
  if (app.extension !== '.py' && app.extension !== '.sh') {
    appAutoLaunch.css('display', 'none');
  }

  return appCard.append(
    appCardContent.append(
      appIcon,
      appDetails.append(
        appName,
        appModifiedDate,
      ),
      appAutoLaunch,
    ),
    appCardAnimatedBackground,
  );
};

interface AppIconProps {
  appExtension: LaunchableAppExtension
}

const AppIcon = ({ appExtension }: AppIconProps): JQuery => {
  switch (appExtension) {
    case '.py':
      return $('<div>').addClass('application_icon icon-python');
    case '.sh':
      return $('<div>').addClass('application_icon icon-bash');
    default:
      return $('<div>').addClass('application_icon icon-launch-sequence-editor');
  }
};
